import { render, staticRenderFns } from "./InsuranceStepModality.vue?vue&type=template&id=1b453494"
import script from "./InsuranceStepModality.vue?vue&type=script&lang=js"
export * from "./InsuranceStepModality.vue?vue&type=script&lang=js"
import style0 from "./InsuranceStepModality.vue?vue&type=style&index=0&id=1b453494&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports